import React, {Component} from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';

class SendAlertAs extends Component {

    constructor(props) {
        super(props);

        this.changeSaveAsSelect = this.changeSaveAsSelect.bind(this);
    }

    changeSaveAsSelect(event) {
        let inputValue = event.target.value;
        this.props.saveData({'sendAs': inputValue});
    }

    render() {

        return (
            <div className='create-alert-page__step-two--send-as-types'>
                <div>
                    <div className='send-title'>
                        <FormattedMessage id='Alerts_Create_UIText_steps.step2.sendAs'/>
                    </div>
                    <select id="create-alert-sendAs"
                            onChange={this.changeSaveAsSelect}
                            value={this.props.data.sendAs}>
                        <option value="ATTACHMENT">
                            {this.props.intl.formatMessage({id: 'Alerts_Create_UIText_steps.step2.attachment'})}
                        </option>
                        <option value="INLINE">
                            {this.props.intl.formatMessage({id: 'Alerts_Create_UIText_steps.step2.inline'})}
                        </option>
                    </select>
                </div>

                {
                    this.props.data.sendAs === 'ATTACHMENT' ?
                        <div>
                            <div className='format-title'>
                                <FormattedMessage id='Alerts_Create_UIText_steps.step2.format'/>
                            </div>
                            <select id=""
                                    onChange={this.changeSaveAsSelect}
                                    value='PDF'
                                    disabled>
                                <option value="PDF">
                                    {this.props.intl.formatMessage({id: 'Entities_Preview_UIText_emailModal.fileFormat.pdf'})}
                                </option>
                            </select>
                        </div>
                        : null
                }

            </div>
        )
    }

}

export default injectIntl(SendAlertAs);


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepTwoComponents/CreateAlert.StepTwo.SendAlertAs.jsx